/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';

import './component004.less';
interface IComponents004Props {
  img: string;
  img1: string;
  className?: string;
}

const Components004: React.FunctionComponent<IComponents004Props> = ({
  img,
  img1,
  className,
}) => (
  <>
    <div className={`RealCase Desktop ${className}`}>
      <img src={require(`../../../../../assets/${img}`).default} alt="" />
      <button
        onClick={() => {
          window.open(
            'https://www.hk01.com/%E7%A0%94%E6%95%B8%E6%89%80/844038/%E5%AF%86%E7%A2%BC%E9%A2%A8%E9%9A%AA-%E9%80%BE%E5%8D%8A%E6%B8%AF%E4%BA%BA%E6%96%BC%E9%80%BE10%E5%80%8B%E7%B6%B2%E7%AB%99%E7%94%A8%E7%9B%B8%E5%90%8C%E5%AF%86%E7%A2%BC-%E8%BF%916%E6%88%90%E4%BA%BA%E5%80%8B%E8%B3%87%E6%9B%BE%E5%A4%96%E6%B4%A9?itm_source=universal_search&itm_campaign=hk01&itm_content=articles&itm_medium=web'
          );
        }}
        className="source1"
      />
      <button
        onClick={() => {
          window.open(
            'https://www.pcpd.org.hk/misc/annual_reports/ar2013_14/ar2013_14/files/assets/common/downloads/PCPD%20Annual%20Report%202013-14.pdf'
          );
        }}
        className="source2"
      />
      <button
        onClick={() => {
          window.open(
            'https://www.pcpd.org.hk/tc_chi/enforcement/case_notes/casenotes_2.php?id=2016DB03&content_type=&content_nature=&msg_id2=542'
          );
        }}
        className="source3"
      />
      <button
        onClick={() => {
          window.open(
            'https://www.am730.com.hk/%E5%9C%8B%E9%9A%9B/%E6%97%A5%E6%9C%AC%E9%A7%90%E6%B8%AF%E9%A0%98%E4%BA%8B%E9%A4%A8%E7%B1%B2%E6%97%A5%E4%BC%81%E6%8F%90%E9%98%B2%E9%9B%BB%E8%A9%B1%E9%A8%99%E6%A1%88-%E9%A8%99%E5%BE%92%E6%93%8D%E6%B5%81%E5%88%A9%E6%97%A5%E8%AA%9E%E6%89%AE%E7%B8%BD%E5%85%AC%E5%8F%B8%E7%A4%BE%E9%95%B7%E8%A6%81%E6%B1%82%E5%8C%AF%E6%AC%BE/347721'
          );
        }}
        className="source4"
      />
    </div>
    <div className={`RealCase Moblie ${className}`}>
      <img src={require(`../../../../../assets/${img1}`).default} alt="" />
      <button
        onClick={() => {
          window.open(
            'https://www.hk01.com/%E7%A0%94%E6%95%B8%E6%89%80/844038/%E5%AF%86%E7%A2%BC%E9%A2%A8%E9%9A%AA-%E9%80%BE%E5%8D%8A%E6%B8%AF%E4%BA%BA%E6%96%BC%E9%80%BE10%E5%80%8B%E7%B6%B2%E7%AB%99%E7%94%A8%E7%9B%B8%E5%90%8C%E5%AF%86%E7%A2%BC-%E8%BF%916%E6%88%90%E4%BA%BA%E5%80%8B%E8%B3%87%E6%9B%BE%E5%A4%96%E6%B4%A9?itm_source=universal_search&itm_campaign=hk01&itm_content=articles&itm_medium=web'
          );
        }}
        className="source1"
      />
      <button
        onClick={() => {
          window.open(
            'https://www.pcpd.org.hk/misc/annual_reports/ar2013_14/ar2013_14/files/assets/common/downloads/PCPD%20Annual%20Report%202013-14.pdf'
          );
        }}
        className="source2"
      />
      <button
        onClick={() => {
          window.open(
            'https://www.pcpd.org.hk/tc_chi/enforcement/case_notes/casenotes_2.php?id=2016DB03&content_type=&content_nature=&msg_id2=542'
          );
        }}
        className="source3"
      />
      <button
        onClick={() => {
          window.open(
            'https://www.am730.com.hk/%E5%9C%8B%E9%9A%9B/%E6%97%A5%E6%9C%AC%E9%A7%90%E6%B8%AF%E9%A0%98%E4%BA%8B%E9%A4%A8%E7%B1%B2%E6%97%A5%E4%BC%81%E6%8F%90%E9%98%B2%E9%9B%BB%E8%A9%B1%E9%A8%99%E6%A1%88-%E9%A8%99%E5%BE%92%E6%93%8D%E6%B5%81%E5%88%A9%E6%97%A5%E8%AA%9E%E6%89%AE%E7%B8%BD%E5%85%AC%E5%8F%B8%E7%A4%BE%E9%95%B7%E8%A6%81%E6%B1%82%E5%8C%AF%E6%AC%BE/347721'
          );
        }}
        className="source4"
      />
    </div>
  </>
);

export default Components004;
